// @flow
import React, {
  type Node,
} from 'react';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';

import type {
  FilterOption,
  FilterType,
  Filters,
} from 'chronos-types';

import filterIcon from 'chronos-assets/images/filter-tool-shape.svg';

import {
  StyledComponent,
  InputList,
  InputListItem,
  ItemTitle,
  FilterIcon,
} from './styled';


type Props = {
  profile: any,
  /**
  * Already selected filters.
  * */
  selectedFilters: Filters,
  /**
   * Function that is called after remove filter.
   * */
  onRemove: { ({ selectedType: FilterType, option: FilterOption }): void },
};

const FilterInput = ({
  profile,
  selectedFilters,
  onRemove,
}: Props): Node => (
  <StyledComponent>
    <FilterIcon src={filterIcon} />
    <InputList>
      {!selectedFilters.length
        && (
          <InputListItem
            key={profile.accountId || profile.key}
            isDefault
          >
            <ItemTitle>
              Users
            </ItemTitle>
            {profile.displayName}
            (you)
          </InputListItem>
        )
      }
      {selectedFilters.map(item => (
        <InputListItem key={`${item.selectedType.value}_${item.option.value}`}>
          <ItemTitle>
            {item.selectedType.label}
          </ItemTitle>
          {item.option.label}
          <div
            onClick={(e) => {
              if (e) e.stopPropagation();
              onRemove({
                selectedType: item.selectedType.value,
                option: item.option,
              });
            }}
          >
            <EditorCloseIcon
              size="small"
              label="remove"
            />
          </div>
        </InputListItem>
      ))}
    </InputList>
  </StyledComponent>
);

FilterInput.defaultProps = {
  permanentFilterKey: null,
};

export default FilterInput;
